import type { IconSvgObject } from './types';

const BounceLeftIcon: IconSvgObject = [
  ["path", { d: "M9 10C11.1153 13.01 12.4407 18.066 13.0872 20.9991C14.4328 18.2908 17 15 20 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "6", cy: "5", r: "2", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BounceLeftIcon;
